import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { actions, selectors, useAppDispatch, useAppSelector } from "store";
import { parameterNames } from "api/tacton/constants";
import { ConvertedNumberInput } from "ui/components/elements/input/converted-number-input";
import { Unit } from "utility/number";
// At 10 cycles per minute each cycle takes 60/10 = 6 seconds; a 6-second
// cycle gives 60/6 = 10 cycles every minute. One cycle moves one part — or
// every lifted box at once when the tool lifts several boxes — so the
// conversion is the same in both modes.
var invertCyclesPerMinuteAndSecondsPerCycle = function (value) {
    return 60 / value;
};
/*
    There is no SecondsPerCycle parameter but this component lets the user enter
    SecondsPerCycle and then commits the value to the PartsPerMinute parameter,
    which the calculation treats as cycles per minute.
*/
export var EditSecondsPerCycle = function () {
    var t = useTranslation().t;
    var dispatch = useAppDispatch();
    var systemDataDefineParameters = useAppSelector(selectors.selectSystemDataDefineParameters);
    var parameter = systemDataDefineParameters === null || systemDataDefineParameters === void 0 ? void 0 : systemDataDefineParameters.parameters[parameterNames.targetPartsPerMinute];
    var setValue = useCallback(function (secondsPerCycle) {
        if (!(parameter === null || parameter === void 0 ? void 0 : parameter.id)) {
            return;
        }
        var cyclesPerMinute = invertCyclesPerMinuteAndSecondsPerCycle(secondsPerCycle);
        dispatch(actions.setParametersDefineParameters({
            parameters: [parameter.id],
            values: [cyclesPerMinute.toString()],
        }));
    }, [dispatch, parameter === null || parameter === void 0 ? void 0 : parameter.id]);
    if (!parameter || !parameter.min || !parameter.max) {
        return null;
    }
    var cyclesPerMinute = Number.parseFloat(parameter.value);
    var secondsPerCycle = invertCyclesPerMinuteAndSecondsPerCycle(cyclesPerMinute);
    // The longest cycle is the slowest allowed speed, and vice versa.
    var secondsPerCycleMax = invertCyclesPerMinuteAndSecondsPerCycle(parameter.min);
    var secondsPerCycleMin = invertCyclesPerMinuteAndSecondsPerCycle(parameter.max);
    return (_jsx(ConvertedNumberInput, { autoFocus: true, label: t("dashboard.sec_per_cycle"), description: parameter.description, min: secondsPerCycleMin, max: secondsPerCycleMax, type: "float", setValue: setValue, value: secondsPerCycle, unit: Unit.S }));
};
